import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ContentService } from '@content/content.service';
import { ContentItem } from '@model/content-item';

export const contentItemResolver: ResolveFn<ContentItem> = (
  route: ActivatedRouteSnapshot,
) => inject(ContentService).get(route.params.uuid as string);
